/**
 * The Validation Messages in this application
 */
class ValidateMessages {
    static incorrect: string = 'The field value is incorrect';
    static required: string = 'This field is required';
    static vowels: string[] = ['a', 'e', 'o', 'i', 'u'];

    static incorrectType = (type: string) => `The value must be ${ValidateMessages.vowels.includes(type.charAt(0).toLowerCase()) ? 'an' : 'a'} ${type}.`;

    static greaterThan = (number: string) => `The value must be greater than ${number}.`;

    static lessThan = (number: string) => `The value must be less than ${number}.`;

    static minLength = (type: string, length: number) => `${type} must be at least ${length} characters.`
    static maxLength = (type: string, length: number) => `${type} must be at most ${length} characters.`
    static min = (type: string, length: number) => `${type} must have at least ${length} entries.`

    static minDate(date: string) {
        return `value must be for at least ${date}.`;
    }

    static maxDate(date: string) {
        return `value must be for at most ${date}.`;
    }
}


export default ValidateMessages;
